export default class DocumentationRule {

  id = "";

  name = "";
  priority = null;

  constructor() {
  }
}
